import { Grid, SxProps, Typography } from '@mui/material';
import {
	subtitleSX,
	titleSX,
	gridItemSX,
	imgSX,
} from '@/components/blocks/DpLibrary/DpCardIconInformation/style/main';
import { Img } from '@/components/blocks/MaterialImage';
import { combineSX } from '@/utils/combineSX';

export const DpCardIconInformation = ({
	image,
	title,
	subtitle,
	framesx,
	imagesx,
	titlesx,
	subtitlesx,
	alt,
}: {
	image: string;
	title: string;
	subtitle: string;
	framesx?: SxProps;
	imagesx?: SxProps;
	titlesx?: SxProps;
	subtitlesx?: SxProps;
	alt?: string;
}) => (
	<Grid
		item
		xs={12}
		sm
		sx={combineSX([gridItemSX, ...(Array.isArray(framesx) ? framesx : [framesx])])}
	>
		<Img
			alt={alt}
			src={image}
			sx={combineSX([imgSX, ...(Array.isArray(imagesx) ? imagesx : [imagesx])])}
		/>
		<Typography
			component="h2"
			sx={combineSX([titleSX, ...(Array.isArray(titlesx) ? titlesx : [titlesx])])}
		>
			{title}
		</Typography>
		<Typography
			sx={combineSX([subtitleSX, ...(Array.isArray(subtitlesx) ? subtitlesx : [subtitlesx])])}
		>
			{subtitle}
		</Typography>
	</Grid>
);
